
import { defineComponent } from "vue";
import KTModalCard from "@/components/cards/Card.vue";

export default defineComponent({
  name: "create-app",
  components: {
    KTModalCard,
  },
});
